import cache from "../utils/cache";

export default {
  //   baseUrl: "https://service.kedaceramics.com",
  //   baseUrl: "https://vosa-service.twyfordtile.top",
  baseUrl: process.env.BASE_URL,

    //斯肯测试
    // baseUrl: "https://vosa.thethinking.cc",

    //森大内网
    // baseUrl: "http://10.86.130.31:30380",

    // baseUrl: "https://vosa.thethinking.cc",
    app_language: "en", // 语言
    app_theme: "default", //主题
    client: "H5", //当前所在的平台
    needKeepAlive: [], //需要缓存的页面
    loading: false,
    position: cache.getSession("position") || [], // 位置 0 国家 1 城市
    google_client_id: "859708357872-bbrq84ks5sja91gbh5tub06kbou7ckvj.apps.googleusercontent.com", // 2024 new
    //google_client_id: "387736425098-aa0ghcaabva6s7gmj9hg4moh7i5j3eim.apps.googleusercontent.com", // x
    // google_client_id: "521022940059-v5ro3nj6h96s60nsimbqhlb43b6fdu5g.apps.googleusercontent.com", // m
    google_api_key: "AIzaSyButS3EjiGaAOTuCQrVHQ__6QUojQyGbMw", // 2025 new
    //google_api_key: "AIzaSyBBlNFZxM4N-QM0GaT-jYDee8rbef8fUiI", // x
    // google_api_key: "AIzaSyCuenMRP2pqL2tx6zIOuOo6xYWZye83vm4", // m
    current: null, // 登录后需要跳转的页面
    routerHistory: cache.getSession("router") || [], // 路由历史
    showRecommended: (cache.getSession("showRecommended") === false? false : true), // 第一次进系统默认显示非谷歌浏览器提示
};



// WEBPACK FOOTER //
// ./src/store/state.js